module.exports = __webpack_public_path__ + "static/media/search.ef6647ff.svg";